const data = {
    title: "set wahtever data you have"
}
const businessProfiles = {
    videoHeading: 'Starting a Business Profile',
    allVideo: [ 
        {
            videoTitle: "Business Registration",
            videoDes: "In this tutorial we show you how to start creating your business account once you have downloaded the Elite Partyz Business App from the App Stores.",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "T2qSqhS8C5U"
        },
        {
            videoTitle: "Setting Up Your Business Profile",
            videoDes: "In this tutorial we show you how to setup and modify your business profile and business settings on the Elite Partyz Business App",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "87k2pXz6DUQ"
        },
        
    ]
}

const services = {
    videoHeading: 'Service Area',
    allVideo: [ 
        {
            videoTitle: "Setting Your Service Area",
            videoDes: "In this tutorial we show you how to set your business coverage area on the Elite Partyz Business App",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "5URt-F83FMQ"
        },
        {
            videoTitle: "Setting Categories & Keywords",
            videoDes: "In this tutorial we show you how to setup your business categories and keywords",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "0b08KETRE5o"
        },
        
    ]
}

const ManagingPayments = {
    videoHeading: 'Managing Profile & Payments',
    allVideo: [ 
        {
            videoTitle: "Add Products & Services",
            videoDes: "In this tutorial we show you how add your businesses products and services",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "4KHG6kWaOo4"
        },
        {
            videoTitle: "Setting Payment Methods",
            videoDes: "In this tutorial we show you how to setup your businesses accepted payment methods",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "czRYP-KIU1k"
        },
        {
            videoTitle: "Managing Payment Requests",
            videoDes: "In this tutorial we show you how to manage your payment requests with your clients",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "9Q-axyC80qg"
        },
        {
            videoTitle: "Processing Payments",
            videoDes: "In this tutorial we show you how to manage processing your clients payments",
            videoOrigin: "https://www.youtube.com/",
            shearingType: "embed",
            videoId: "t88NVx_TGvs"
        },
    ]
}

export default data
export { businessProfiles, services, ManagingPayments }
